// extracted by mini-css-extract-plugin
module.exports = {"metric-cell":"MetricCell_metric-cell__2Ce_T"};